import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DistributionArtFileComponent } from '../distribution-art-file/distribution-art-file.component';
import { MainService } from 'src/app/services/main.service';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { DistributionArtProductComponent } from '../distribution-art-product/distribution-art-product.component';
import Swal from 'sweetalert2';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SkuImageComponent } from '../sku-image/sku-image.component';
import { DistributionArtPreviewComponent } from '../distribution-art-preview/distribution-art-preview.component';

@Component({
  selector: 'app-distribution-art',
  templateUrl: './distribution-art.component.html',
  styleUrls: ['./distribution-art.component.scss']
})
export class DistributionArtComponent implements OnInit {

  strategy: any;
  artFiles: any;
  isLoading = true;
  canUploadArt: boolean = false;
  skus: { idStrategySku: number, id_sku: number, sku: string, nombre: string, numFiles: number, ancho: number, alto: number, ultimo_uso: string, product_name: string, id_family: number, nombre_archivo: string, archivo: string, paginas: number, file_respuesta: string, file_respuesta_report: string, fileUrl: SafeResourceUrl, fileUrlReport: SafeResourceUrl,  nombre_ftp: string, bitValido: number, id_archivo: number, family: string, pagesMedidasDif: number}[] = [];
  contFiles: number = 0;
  mostrarSeleccionSku = true;
  artes: { nombre_archivo: string, archivo: string, sku: string, nombre: string, bitValido: number, blob: string, file_respuesta: string, file_respuesta_report: string, nombre_file: string, nombre_file_report: string, fileUrl: SafeResourceUrl, fileUrlReport: SafeResourceUrl, fileUrlArte: SafeResourceUrl, id_archivo: number, nombre_ftp: string  }[] = [];
  skusOdoo: any;
  arrIdsSkus: any = [];
  archivos: any = [];
  folder_camp: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private campaignService : CampaignsService,
    private main : MainService,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<DistributionArtComponent>,
    public sanitizer: DomSanitizer,
  ) {
    this.strategy = this.data.strategy;
    this.folder_camp = this.data.folder_camp;
    this.loadData();
    this.canUploadArt = !this.data.islocked && this.campaignService.hasPermissions("upl_art",false,true);
   }

  ngOnInit(): void {
    
  }

  async loadData(){
    this.main.ShowLoading();
    this.campaignService.getStrategySkus(this.strategy.id).subscribe(
      async (result:any) => {

        this.skus = result.data;
        this.main.HideLoading();

        await Promise.all(
          this.skus.map(async (item) => {

            if (item.file_respuesta_report == null && item.pagesMedidasDif == 0) {
              const respuesta = await this.obtenerFilesFtp(item.nombre_ftp, item.id_archivo);

              if (respuesta?.fileUrlReport) {
                item.file_respuesta = respuesta.fileUrl;
                item.file_respuesta_report = respuesta.fileUrlReport;
                item.bitValido = respuesta.bitValido;
              }
            }
          })
        );

      },
      (err:any) => {
        if(err.error.message != "No data were found in the request")
        {
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener registros',
            text: 'Ocurrió un error al obtener los registros.'
          });
        }
      }
    );
  }

  openDialogArtNewProduct() {
    this.matDialog.open(DistributionArtProductComponent, {
      panelClass: ['dialogs-md'],
      closeOnNavigation: false,
      data: {
        folder_camp: this.folder_camp,
        strategy : this.data.strategy
      }
    }).afterClosed().subscribe(
      resp => {
        this.loadData();
        this.contFiles++;
      }
    );
  }

  deleteArtes(id_family: number){

    Swal.fire({
        title: "¿Seguro que quieres eliminarlo?",
        text: "No podrás revertir esta acción",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar"
      }).then((result) => {
          if (result.isConfirmed) {
            this.campaignService.deleteStrategyArtes(id_family, this.strategy.id).subscribe(
              (result:any) => {
                Swal.fire("Eliminado", "", "success");
                this.loadData();
              },
              (err:any) => {
                if(err.error.message != "No data were found in the request")
                {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error al eliminar el producto',
                    text: 'Ocurrió un error al eliminar el registro.'
                  });
                }
              }
            );
          }
      });

  }

  obtenerFilesFtp(nombre_arte: string, id_archivo: number): Promise<any> {

    return new Promise((resolve, reject) => {

      let intentos = 0;
      const maxIntentos = 3;
      let intervalo: ReturnType<typeof setTimeout>;

      const consultarArchivo = () => {
        intentos++;

        this.campaignService.getFilesFtp(nombre_arte, id_archivo, 1).subscribe(
          (result: any) => {
            if (result.noEncontrado != 4) {
              clearTimeout(intervalo);
              resolve(result);
              return;
            }

            console.log(`Archivo no encontrado. Intento ${intentos} de ${maxIntentos}`);

            if (intentos >= maxIntentos) {
              resolve({
                mensaje: 'No se pudo obtener el archivo, intente mas tarde'
              });
              return;
            }

            intervalo = setTimeout(consultarArchivo, 15000);
          },
          (err: any) => {
            clearTimeout(intervalo);
            reject(err);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Ocurrió un error al obtener los archivos.'
            });
          }
        );
      };

      consultarArchivo();

    })

  }

  openDialogArte(element: any) {
    const dialogRef = this.matDialog.open(SkuImageComponent, {
      width: '95vw',       
      maxWidth: '1800px',   
      height: '95vh',
      data : element
    })
  }

  openDialogHistorial(idSku: number, medidaX: number, medidaY: number, idFamily: number, family: string) {
    this.matDialog.open(DistributionArtFileComponent, {
      panelClass: ['dialogs-md'],
      data: {
        strategy : this.data.strategy,
        idSku: idSku,
        medida_x: medidaX,
        medida_y: medidaY,
        toggleEnfocus: 0,
        idFamily: idFamily,
        family: family
      }
    }).afterClosed().subscribe(
      resp => {
        this.loadData()
      }
    );
  }
  
  openPreview() {
    const previewUrl = this.artFiles?.[0]?.url_cli;

    if (!this.isPdfUrl(previewUrl)) {
      Swal.fire({
        icon: 'warning',
        title: 'Archivo no compatible',
        text: 'La vista previa sólo está disponible para archivos PDF.'
      });
      return;
    }

    this.matDialog.open(DistributionArtPreviewComponent, {
      panelClass: ['dialogs-xl'],
      data: {
        strategy : this.data.strategy,
        artFiles: this.artFiles,
        tipo: 1
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) {
          this.dialogRef.close({ reload: true });
        }
      }
    );
  }

  private isPdfUrl(url?: string): boolean {
    if (!url) {
      return false;
    }

    try {
      const parsedUrl = new URL(url);
      const isHttpUrl = parsedUrl.protocol === 'https:' || parsedUrl.protocol === 'http:';
      return isHttpUrl && parsedUrl.pathname.toLowerCase().endsWith('.pdf');
    } catch {
      return false;
    }
  }

}
